import WishlistController from "@controller/wishlist/wishlistController";
import BaseLayout from "@layout/base-layout";
import { Button, Input, Modal } from "antd";
import WishlistCom from "components/wishlist/WishlistCom";
import { observer } from "mobx-react";
import { i18n, useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import BannerView from "../../../src/components/frontpage/banner_view";

const Controller = new WishlistController();

const WishlistIndex = observer((props) => {
  const [showModal, setShowModal] = useState(false);

  const { t } = useTranslation("common");
  const router = useRouter();
  let changedTitle = "";

  const titleHandle = (event) => {
    changedTitle = event.target.value;
  };

  useEffect(() => {
    Controller.getData();
  }, []);

  const changeTitleHandle = () => {
    Controller.create({ title: changedTitle }, (id) =>
      router.push(`/user/wishlist/view?id=${id}`)
    );
    setShowModal(false);
  };

  return (
    <div className="mt-[43px] mx-auto ">
      <Head>
        <title>Moverii Wishlist</title>
      </Head>
      <Modal
        open={showModal}
        footer={false}
        onCancel={() => setShowModal(false)}
        className="wishlist-modal"
        destroyOnClose
        centered
      >
        <div>
          <h2 className="text-[22px] leading-8 font-semibold text-grayDark2 text-center">
            {t("wishlist.Create_your_wishlist")}
          </h2>
          <p className="text-base text-center mt-2">
            {t("wishlist.Create_your_wishlist_desc")}
          </p>
          <div className="relative mt-8 wishlist-modal-input">
            <p className="absolute lable-wishlist-edit text-gray-50">
              {t("wishlist.Name_of_the_wishlist")}
            </p>
            <Input onChange={titleHandle} className="!pl-5" />
          </div>
          <div className="flex justify-around items-center mt-6 mb-2">
            <Button
              className="rounded-[22px] btn-orange py-[6px] px-10 text-[16px] leading-[24px] font-bold !bg-orange hover:!bg-orange !border-none"
              onClick={changeTitleHandle}
            >
              {t("wishlist.Save")}
            </Button>
          </div>
        </div>
      </Modal>

      <div className="!container px-6 md:px-0">
        <div
          className={
            "grid grid-cols-1 md:grid-cols-2 gap-y-4 md:gap-y-0 mb-10 md:mb-0"
          }
        >
          <h1 className="text-grayDark2 font-bold text-[32px] leading-[45px] text-left">
            {t("wishlist.Your_wishlists")}
          </h1>
          <div className="justify-center md:justify-end hidden md:flex">
            <Button
              className="rounded-2xl btn-orange py-2 px-12 text-[18px] font-bold !bg-orange hover:!bg-orange !border-none w-full md:w-auto"
              icon={
                <span className="mr-1">
                  <img src="/icon/plus.svg" />
                </span>
              }
              onClick={() => setShowModal(true)}
            >
              {t("wishlist.New_wishlist")}
            </Button>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 justify-center items-center lg:items-left lg:justify-start gap-5 mt-5">
          {Controller.list.map((item, index) => {
            return (
              <Link href={`/user/wishlist/view?id=${item.id}`}>
                <a href={`/user/wishlist/view?id=${item.id}`}>
                  <WishlistCom item={item} key={"s" + index} />
                </a>
              </Link>
            );
          })}
        </div>
        <div className="justify-center md:justify-end md:hidden flex mt-8">
          <Button
            className="rounded-2xl btn-orange py-2 px-12 text-[18px] font-bold !bg-orange hover:!bg-orange !border-none w-full md:w-auto"
            icon={
              <span className="mr-1">
                <img src="/icon/plus.svg" />
              </span>
            }
            onClick={() => setShowModal(true)}
          >
            {t("wishlist.New_wishlist")}
          </Button>
        </div>
      </div>

      <div className="!mb-10 md:!mb-[100px] mt-16">
        <BannerView />
      </div>
    </div>
  );
});

WishlistIndex.Layout = BaseLayout;
export const getServerSideProps = async ({ locale }) => {
  if (process.env.NODE_ENV === "development") {
    await i18n?.reloadResources();
  }

  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
};
export default WishlistIndex;
